import { BarChartRounded, Info, ListRounded } from '@mui/icons-material'
import { Box, Grid, IconButton, Tab, Tooltip, Typography } from '@mui/material'
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyledTabs } from '../../../../shared/components/StyledTabs'
import TabPanel from '../../../../shared/components/TabPanel'
import useTabState from '../../../../shared/hooks/useTabState'
import usePopularDetailContent from '../hooks/usePopularDetailContent'
import { InfoContent } from '../styles/GraphsStyles'
import PopularContentChart from './PopularContentChart'

function MostPopularContent() {
  const { t } = useTranslation(['global'])

  const [display, setDisplay] = useState<number>(1)
  const { currentTab, setCurrentTab, a11yProps } = useTabState()

  const { menuCodes, reports } = usePopularDetailContent()

  const getRowId = (row: any) => row.foreign_id
  const columns: GridColDef[] = [
    { field: 'foreign_id', headerName: '#' },
    {
      field: 'foreign_name',
      headerName: t('name'),
      flex: 1,
      renderCell: (params: any) => (
        <Box display="flex" alignItems="center" gap={1} my={1} width="100%">
          <Box
            style={{
              backgroundImage: `url(${params.row.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '32px',
              width: '32px',
              borderRadius: '4px'
            }}
          />
          <InfoContent display={'flex'} flexDirection={'column'}>
            <Typography variant="body2">{params.value}</Typography>
          </InfoContent>
        </Box>
      )
    },
    { field: 'value', headerName: t('views') }
  ]

  return (
    <Box width="100%">
      <Box width={'100%'} display={'flex'} justifyContent="space-between" alignItems={'center'}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
            '& h6': {
              color: 'grey.700'
            },
            '& svg': {
              color: 'grey.400'
            }
          }}
        >
          <Typography variant="subtitle1">{t('most-popular-content')}</Typography>
          <Tooltip
            placement="bottom"
            title={
              <Box maxWidth={'240px'}>
                <Typography variant="caption">{t('most-popular-content-quote')}</Typography>
              </Box>
            }
          >
            <Info fontSize="small" />
          </Tooltip>
        </Box>
        {/* Botón para cambiar de visualización(display) entre gráficas o tabla */}
        {display ? (
          <Tooltip title={`${t('change-view-to-list')}`}>
            <IconButton onClick={() => setDisplay(0)}>
              <ListRounded color="secondary" />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title={`${t('change-view-to-graphic')}`}>
            <IconButton onClick={() => setDisplay(1)}>
              <BarChartRounded color="secondary" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <Grid item xs={12}>
        <StyledTabs
          value={currentTab}
          variant="fullWidth"
          onChange={(_, newValue) => setCurrentTab(newValue)}
          aria-label="disabled tabs example"
        >
          {menuCodes.map((menuCode: string, index: number) => (
            <Tab key={menuCode} label={t(menuCode)} {...a11yProps(index)} />
          ))}
        </StyledTabs>
      </Grid>
      {/* Gráfica con top 5 contenidos mas populares entre ofertas y biblioteca*/}
      {menuCodes.map((menuCode: string, index: number) => (
        <TabPanel key={menuCode} value={currentTab} index={index}>
          {display ? (
            reports[menuCode].length > 0 ? (
              <PopularContentChart data={reports[menuCode]} dataName={'Visualizaciones'} />
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 360,
                  color: 'grey.500'
                }}
              >
                <Typography>{t('no-records')}</Typography>
              </Box>
            )
          ) : (
            <div className="table_analitics">
              <DataGrid
                rows={reports[menuCode] as GridRowsProp<any>}
                columns={columns}
                getRowId={getRowId}
                disableColumnMenu
                autoHeight
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: 6, page: 0 }
                  }
                }}
                pageSizeOptions={[6]}
              />
            </div>
          )}
        </TabPanel>
      ))}
    </Box>
  )
}

export default MostPopularContent
